export default __webpack_public_path__ + "static/media/qr-bridge-prod.c135dc56.png";